import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { Badge } from 'designSystem/components/Badge'
import type { EvalPageTrailDecision } from 'features/knowledgeDocumentViewer/utils/pageMetadataEvalTrail'
import React from 'react'

const STATUS_CHIP: Record<
  EvalPageTrailDecision,
  {
    label: MessageDescriptor
    variant: 'outlineMuted' | 'default' | 'secondary'
  }
> = {
  unlabeled: { label: msg`Unlabeled`, variant: 'outlineMuted' },
  confirmed: { label: msg`Confirmed`, variant: 'default' },
  deferred: { label: msg`Deferred`, variant: 'secondary' },
}

export type PageMetadataEvalStatusChipProps = {
  status: EvalPageTrailDecision
}

export function PageMetadataEvalStatusChip({
  status,
}: PageMetadataEvalStatusChipProps): React.ReactElement {
  const { i18n } = useLingui()
  const chip = STATUS_CHIP[status]
  return <Badge variant={chip.variant}>{i18n._(chip.label)}</Badge>
}
